import { Head, Link } from "@inertiajs/react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { CheckCircle, Sparkles, Clock, Cog } from "lucide-react";

export default function Dashboard({
  pending_product_count,
  ready_for_analysis_product_count,
  valid_product_count,
  pending_jobs_count,
}) {
  const productCards = [
    {
      title: "Validés",
      description: "Disponibles pour les utilisateurs",
      count: valid_product_count,
      href: "/admin/products?status=validated",
      color: "bg-emerald-50 border-emerald-200 hover:bg-emerald-100",
      countColor: "text-emerald-600",
      icon: CheckCircle,
      iconColor: "text-emerald-500",
    },
    {
      title: "Prêts pour analyse",
      description: "Informations complètes, en attente d'analyse par l'IA",
      count: ready_for_analysis_product_count,
      href: "/admin/products?status=ready_for_analysis",
      color: "bg-blue-50 border-blue-200 hover:bg-blue-100",
      countColor: "text-blue-600",
      icon: Sparkles,
      iconColor: "text-blue-500",
    },
    {
      title: "En attente d'information",
      description: "Produits scannés, en attente d'informations supplémentaires (nom, marque, ingrédients)",
      count: pending_product_count,
      href: "/admin/products?status=pending",
      color: "bg-amber-50 border-amber-200 hover:bg-amber-100",
      countColor: "text-amber-600",
      icon: Clock,
      iconColor: "text-amber-500",
    },
  ];

  return (
    <div className="p-6">
      <Head title="Tableau de bord" />
      <h1 className="text-2xl font-bold mb-6">Tableau de bord</h1>

      <h2 className="text-lg font-semibold mb-3 text-gray-700">Produits</h2>
      <div className="flex flex-col gap-4 mb-8">
        {productCards.map((card) => (
          <Link key={card.title} href={card.href}>
            <Card className={`hover:shadow-md transition-all cursor-pointer ${card.color}`}>
              <CardHeader>
                <div className="flex items-center gap-3">
                  <card.icon className={`w-6 h-6 ${card.iconColor}`} />
                  <div>
                    <CardTitle>{card.title}</CardTitle>
                    <CardDescription>{card.description}</CardDescription>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <p className={`text-4xl font-bold ${card.countColor}`}>{card.count}</p>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>

      <h2 className="text-lg font-semibold mb-3 text-gray-700">Système</h2>
      <div className="flex flex-col gap-4">
        <Link href="/admin/jobs">
          <Card
            className={`hover:shadow-md transition-all cursor-pointer ${pending_jobs_count === 0 ? "bg-emerald-50 border-emerald-200 hover:bg-emerald-100" : "bg-amber-50 border-amber-200 hover:bg-amber-100"}`}
          >
            <CardHeader>
              <div className="flex items-center gap-3">
                <Cog className={`w-6 h-6 ${pending_jobs_count === 0 ? "text-emerald-500" : "text-amber-500"}`} />
                <div>
                  <CardTitle>Jobs</CardTitle>
                  <CardDescription>Tâches automatiques (analyses, etc.)</CardDescription>
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <p className={`text-4xl font-bold ${pending_jobs_count === 0 ? "text-emerald-600" : "text-amber-600"}`}>
                {pending_jobs_count === 0 ? "OK" : `${pending_jobs_count} en attente`}
              </p>
            </CardContent>
          </Card>
        </Link>
      </div>
    </div>
  );
}
